import experiencesJson from "./experiences.json";
import profileJson from "./profile.json";
import projectsJson from "./projects.json";
import skillsJson from "./skills.json";

export const profile = profileJson;
export const focus = profileJson.about.focus;

export type Skill = {
  name: string;
  point: number;
  desc: string;
};

export const skills: Skill[] = skillsJson;

export type Experience = {
  start: string;
  end: string;
  company: string;
  department: string;
  position: string;
  desc: string;
};

export const experiences: Experience[] = experiencesJson;

export type Project = {
  slug: string;
  name: string;
  period: string;
  org: string;
  role: string;
  tags: string[];
  summary: string;
};

export const projects: Project[] = projectsJson;

export const values = [
  {
    id: "lazy",
    index: "01",
    title: "从简",
    line: "少绕路。",
    detail: "把难的做成方便的，把繁的做成简单的。",
  },
  {
    id: "curious",
    index: "02",
    title: "好奇",
    line: "先看懂，再决定用不用。",
    detail: "对技术保持兴趣，热衷把新知识拆开看。",
  },
  {
    id: "adapt",
    index: "03",
    title: "适应",
    line: "环境一变，方案就换。",
    detail: "学得快，才能在新老项目之间换挡。",
  },
  {
    id: "ship",
    index: "04",
    title: "做成",
    line: "讨论清楚，然后交付。",
    detail: "带上一起做的人，把事情按时做完。",
  },
];

export const nav = [
  { href: "/", label: "理念" },
  { href: "/about", label: "关于" },
  { href: "/projects", label: "作品" },
  { href: "/blog", label: "笔记" },
  { href: "/lab", label: "实验室" },
];
